import React from "react";
import { TexturedPlaneMesh } from "../TexturedPlaneMesh";
import { useResourcesState } from "@/state/resourcesState";
import { useDemoState } from "@/state/demoState";
import { Wall } from "./Wall";
import { Light } from "../../Light";
import { useDebugState } from "@/state/debugState";
import { SELECTED_ITEM_TYPE } from "@/3d/SelectedItem";
export const Room: React.FC = () => {
    const { materials, isLoaded } = useResourcesState();
    const isSettingUpLighting = useDebugState((state) => state.isSettingUpLighting);

    const roomConfig = useDemoState((state) => state.roomConfig);
    const lightConfig = useDemoState((state) => state.lightConfig);
    const { width, depth, floorColor, leftWall, rightWall, frontWall, backWall } = roomConfig;

    if (!materials || !isLoaded) {
        return null;
    }

    const floor = materials["WoodFloor039"].textures;
    const wall = materials["Wallpaper002A"].textures;

    return (
        <group>
            <TexturedPlaneMesh
                width={width}
                height={depth}
                position={[0, 0, 0]}
                rotation={[-Math.PI / 2, 0, 0]}
                textures={floor}
                receiveShadow={true}
                color={floorColor}
                selectedItem={{ selectedItemType: SELECTED_ITEM_TYPE.FLOOR }}
            />
            <mesh rotation={[Math.PI / 2, 0, 0]} position={[0, roomConfig.height, 0]}>
                <planeGeometry args={[width, depth]} />
                <meshPhysicalMaterial
                    roughness={1}
                    metalness={0}
                    toneMapped={false}
                    color="white"
                    emissive={"white"}
                    emissiveIntensity={0.5}
                />
            </mesh>
            <Wall room={roomConfig} textures={wall} wall={leftWall} />
            <Wall room={roomConfig} textures={wall} wall={rightWall} />
            <Wall room={roomConfig} textures={wall} wall={frontWall} />
            <Wall room={roomConfig} textures={wall} wall={backWall} />

            {lightConfig.map((config) => (
                <Light key={config.type} config={config} drawHelpers={isSettingUpLighting} />
            ))}
        </group>
    );
};
